export enum TipoProprietarioEnum {
  Propria = 1,
  Arrendada,
  Terceiros
}
